<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — PUBLIC NEWS SECTION (HOME)
     ════════════════════════════════════════════════ -->
<section class="blog-area" [class.dark-courses-area]="themeService.isDark()">
  <div class="container">

    <!-- Section Title -->
    <div class="section-title text-start" style="margin-bottom: 2rem;">
      <span class="sub-title">الأخبار العامة</span>
    </div>

    <!-- Category Tabs -->
    <ul class="nav-tabset">
      <li class="nav-tab"
          *ngFor="let category of categoryNews"
          [ngClass]="{'active': currentTab === category?.referenceId}"
          (click)="switchTab($event, category?.referenceId)">
        <span>{{ category?.categoryNewsName }}
          <span style="opacity:0.6;">({{ getNewsCountByCategory(category?.referenceId) }})</span>
        </span>
      </li>
    </ul>

    <!-- Cards -->
    <div class="tabs-container">
      <div *ngFor="let category of categoryNews">
        <div class="pane" [id]="category?.referenceId" *ngIf="currentTab === category?.referenceId">
          <div class="row">
            <div *ngFor="let news of getPublicNewsByCategory(category?.referenceId)"
                 class="col-lg-4 col-md-6"
                 style="margin-bottom: 1.5rem;">

              <div class="vfu-card">
                <div class="vfu-card-img">
                  <a [routerLink]="'/public-news-details/' + news?.referenceId">
                    <img [src]="news.img1" alt="{{ news?.title }}">
                  </a>
                  <span class="vfu-card-tag">{{ category?.categoryNewsName }}</span>
                </div>

                <div class="vfu-card-body">
                  <div class="vfu-card-meta">
                    <i class='bx bx-calendar'></i>
                    <span>{{ news?.creationDate | date:'d MMMM y' }}</span>
                  </div>

                  <div class="vfu-card-title">
                    <a [routerLink]="'/public-news-details/' + news?.referenceId">
                      {{ news?.title }}
                    </a>
                  </div>

                  <p class="vfu-card-excerpt">{{ news?.shortText }}</p>

                  <a [routerLink]="'/public-news-details/' + news?.referenceId" class="vfu-read-more">
                    {{"MENU.ReadMore" | translate}}
                    <i class='bx bx-left-arrow-alt'></i>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</section>
